'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { AdvancedFilter } from '@morpho-org/ui-v6/client';
import { xor } from 'lodash-es';
import { memo, type ReactNode, useCallback, useMemo, useState } from 'react';
export interface CuratorItem {
  id: string;
  name: string;
  image: string | null;
  addresses?: Array<{
    address: string;
    chainId: number;
  }>;
  /** Total matching vault count from the API facet, shown next to the option. */
  count?: number;
}
function isCuratorSelected(curator: CuratorItem, selectedCurators: string[]) {
  return selectedCurators.includes(curator.id);
}
interface CuratorFilterProps {
  curators: CuratorItem[];
  curatorIds: string[];
  chainIds?: ChainId[];
  onCuratorIdsChange: (curatorIds: string[]) => void;
  disabled: boolean;
  allLabel: string;
  hasHighestZIndex?: boolean;
  resultLabel?: ReactNode;
}
const CuratorFilter = t0 => {
  const $ = _c(32);
  const {
    curators,
    curatorIds,
    chainIds,
    onCuratorIdsChange,
    disabled,
    allLabel,
    hasHighestZIndex,
    resultLabel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [sortedIds, setSortedIds] = useState(t1);
  let t2;
  if ($[1] !== chainIds || $[2] !== curatorIds || $[3] !== curators || $[4] !== sortedIds) {
    bb0: {
      let t3;
      if ($[6] !== chainIds) {
        t3 = curator => {
          if (!curator.addresses?.length) {
            return true;
          }
          if (!chainIds?.length) {
            return true;
          }
          return curator.addresses.some(address => chainIds.includes(address.chainId));
        };
        $[6] = chainIds;
        $[7] = t3;
      } else {
        t3 = $[7];
      }
      let t4;
      if ($[8] !== curatorIds) {
        t4 = curator_0 => ({
          id: curator_0.id,
          label: curator_0.name,
          value: curator_0.id,
          img: curator_0.image,
          isChecked: isCuratorSelected(curator_0, curatorIds),
          count: curator_0.count
        });
        $[8] = curatorIds;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      const mapped = curators.filter(t3).map(t4);
      if (sortedIds.length === 0) {
        t2 = mapped;
        break bb0;
      }
      let t5;
      if ($[10] !== sortedIds) {
        t5 = new Map(sortedIds.map(_temp));
        $[10] = sortedIds;
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      const orderIndex = t5;
      let t6;
      if ($[12] !== orderIndex) {
        t6 = (a, b) => {
          const aIdx = orderIndex.get(a.id) ?? Infinity;
          const bIdx = orderIndex.get(b.id) ?? Infinity;
          return aIdx - bIdx;
        };
        $[12] = orderIndex;
        $[13] = t6;
      } else {
        t6 = $[13];
      }
      t2 = mapped.toSorted(t6);
    }
    $[1] = chainIds;
    $[2] = curatorIds;
    $[3] = curators;
    $[4] = sortedIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const items = t2;
  let t3;
  if ($[14] !== curatorIds || $[15] !== curators) {
    t3 = () => {
      const sorted = [...curators].toSorted((a_0, b_0) => {
        const aInFilter = Number(isCuratorSelected(a_0, curatorIds));
        const bInFilter = Number(isCuratorSelected(b_0, curatorIds));
        return bInFilter - aInFilter || a_0.name.localeCompare(b_0.name);
      });
      setSortedIds(sorted.map(_temp2));
    };
    $[14] = curatorIds;
    $[15] = curators;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const sortCurators = t3;
  let t4;
  if ($[17] !== curatorIds || $[18] !== onCuratorIdsChange) {
    t4 = curatorId => {
      const newCuratorIds = xor(curatorIds, [curatorId]);
      onCuratorIdsChange(newCuratorIds);
    };
    $[17] = curatorIds;
    $[18] = onCuratorIdsChange;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const toggleItem = t4;
  let t5;
  if ($[20] !== onCuratorIdsChange) {
    t5 = () => {
      onCuratorIdsChange([]);
    };
    $[20] = onCuratorIdsChange;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const clear = t5;
  const t6 = curatorIds.length > 0;
  let t7;
  if ($[22] !== allLabel || $[23] !== clear || $[24] !== disabled || $[25] !== hasHighestZIndex || $[26] !== items || $[27] !== resultLabel || $[28] !== sortCurators || $[29] !== t6 || $[30] !== toggleItem) {
    t7 = <AdvancedFilter items={items} sortItems={sortCurators} toggleItem={toggleItem} clear={clear} inputPlaceholder="Search for curator" clearTooltipText="Remove Curator filter" disabled={disabled} allLabel={allLabel} hasHighestZIndex={hasHighestZIndex} resultLabel={resultLabel} hasSelection={t6} />;
    $[22] = allLabel;
    $[23] = clear;
    $[24] = disabled;
    $[25] = hasHighestZIndex;
    $[26] = items;
    $[27] = resultLabel;
    $[28] = sortCurators;
    $[29] = t6;
    $[30] = toggleItem;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
};
export default memo(CuratorFilter);
function _temp(id, index) {
  return [id, index];
}
function _temp2(curator_1) {
  return curator_1.id;
}